'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useCurrentPath } from 'src/hooks/useCurrentPath';
import { checkLogin } from 'src/utils/auth';

interface PrivateAuthProviderProps {
  children: React.ReactNode;
  shouldRenderChildren?: boolean;
}

export default function PrivateAuthProvider({ children, shouldRenderChildren = true }: PrivateAuthProviderProps) {
  const router = useRouter();
  const currentPath = useCurrentPath();

  useEffect(() => {
    if (!checkLogin()) {
      router.push(`/account/logout?retUrl=${currentPath}`);
    }
  }, []);

  return <>{shouldRenderChildren ? children : <div className="min-h-screen" />}</>;
}
